<!--
 * @Author: DY
 * @Date: 2024-12-10 11:54:54
 * @LastEditTime: 2024-12-26 10:19:15
 * @Description: 入库记录
 * @FilePath: \ShiMo_Mobile\src\views\storage\inventoryInquiry\storageRecord.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="storageRecord commonListStyles">
            <HeaderNav
                header-title="入库记录"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo" @click="openMovingInventory(item)">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">入库编号：{{ item.instock_number }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>入库单据类型：{{ item.instock_type }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>供应商：{{ item.supplier_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>采购部门：{{ item.dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>入库人：{{ item.instock_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_32@2x.png" alt="">
                                            <span>入库前库存：{{ item.volume_before }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_16@2x.png" alt="">
                                            <span>入库数量：{{ item.volume_already }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_32@2x.png" alt="">
                                            <span>入库后库存：{{ item.volume_after }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>库位名称：{{ item.grid_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>入库时间：{{ item.instock_time }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'storage-record',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/inventoryInquiry') {
            this.$store.commit('noKeepAlive', 'storage-record');
        }
        next();
    },
    data() {
        return {
            cacheKey: Math.floor(Math.random() * 1000000000000 + 1),
            tableCode: 'material_instock_record',
            requestUrl: '',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {},
    created() {
        const material_code = this.$route.params.data.MaterialCode;
        const stock_id = this.$route.params.data.StockId;
        this.requestUrl = `/basicplatform/tabledata?material_code=${material_code}&stock_id=${stock_id}`;
    },
    mounted() {},
    methods: {
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/inventoryInquiry' });
        },
    },
};
</script>
<style lang="stylus"></style>
